import React, { FC, useEffect, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

import { Customer } from 'services/checkout-service/models'

import { SetPaymentOverlayType } from '../../CloverPaymentSection';
import { WalletSubmitPaymentType } from '../';
import { doRecaptcha } from 'utils/Recaptcha';


export type WalletButtonProps = {
  paymentReqData: any;
  cloverElementsInstance?: Clover.ElementRoot;
  onWalletSubmit: WalletSubmitPaymentType;
  setPaymentOverlays: SetPaymentOverlayType;
  customerInfo?: Partial<Customer>;
  isRecaptchaEnabled: boolean;
  // recaptchaRef: React.RefObject<ReCAPTCHA>;
};

const GpayButton: FC<WalletButtonProps> = ({
  paymentReqData,
  cloverElementsInstance,
  onWalletSubmit,
  setPaymentOverlays,
  customerInfo,
  isRecaptchaEnabled,
}) => {
  const [walletElement, setWalletElement] = useState<any>();

  const paymentMethodCallback = async (data: any) => {
    let recaptchaToken = undefined;
    if (isRecaptchaEnabled) {
      // TODO: Show a error on recaptcha API failure.
      // @ts-ignore
      recaptchaToken = await doRecaptcha(window["recaptchaRef"], undefined);
      if (!recaptchaToken) {
        console.error("Failed to generate recaptcha token");
        return;
      }
    }

    if (data.token) {
      // Notify callback not needed for gpay.
      onWalletSubmit(
        data,
        () => {/**/},
        'G_PAY',
        recaptchaToken || ''
      );
    }
  };

  useEffect(() => {
    if (walletElement) {
      walletElement.removeEventListener('paymentMethod');
      walletElement.addEventListener('paymentMethod', paymentMethodCallback);
    }
    /** Adding the dependency of the customer object, as on updating the customer,
    this block of function will aloso get the updated instance of the customer object. */
  }, [paymentReqData.total.amount, customerInfo]);

  useEffect(() => {
    if (!cloverElementsInstance) return;

    const gPayWalletEle = cloverElementsInstance.create('PAYMENT_REQUEST_BUTTON', {
      paymentReqData,
    });
    setWalletElement(gPayWalletEle);

    if (gPayWalletEle) {
      gPayWalletEle.mount('#payment-request-button');
      gPayWalletEle.addEventListener('paymentMethodStart', () => {
        // Show overlay here.
        // Not adding a callback for paymentMethodEnd to hide the overlay
        // as that is controlled by the app after charge
        // rather than by the wallet after tokenization.
        setPaymentOverlays(true);
      });
      gPayWalletEle.addEventListener('paymentMethod', paymentMethodCallback);
    }

    return () => {
      if (walletElement) {
        walletElement.removeEventListener('paymentMethod');
        walletElement.removeEventListener('paymentMethodStart');
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cloverElementsInstance]);

  return <div id="payment-request-button" />;
};

export { GpayButton };
